import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Shield, Eye, EyeOff } from "lucide-react";
import { useAuth, API } from "../context/AuthContext";

export default function SystemAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Enter email and password");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      login(res.data.token, { role: "admin", name: res.data.name });
      toast.success("Login successful");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#f8fafc] to-[#e2e8f0]">
      <div className="w-12 h-12 rounded-full bg-[#1e3a5f] flex items-center justify-center mb-4">
        <Shield className="w-6 h-6 text-white" />
      </div>
      <h1 className="text-2xl font-extrabold text-[#1e3a5f] mb-1">System Admin</h1>
      <p className="text-slate-500 text-sm mb-6">Platform Management</p>

      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-3">
        <input
          type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="Email" className="w-full p-4 rounded-2xl border bg-white"
        />
        <div className="relative">
          <input
            type={showPw ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Password" className="w-full p-4 rounded-2xl border bg-white pr-12"
          />
          <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400">
            {showPw ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        <button type="submit" disabled={loading} className="w-full py-4 rounded-full bg-[#1e3a5f] text-white font-bold disabled:opacity-50">
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <button onClick={() => navigate("/")} className="mt-8 text-slate-400 text-sm hover:underline">Back to Home</button>
    </div>
  );
}
